import { Route, Switch } from 'react-router-dom';

// Components
import Send from './send';
import History from './history';

export default function Attentions({
  match,
  history,
  webservice,
  getCookie,
  device,
  setSessionMessage,
}) {
  return (
    <div>
      <Switch>
        <Route
          path={`${match.path}/myAttentions`}
          render={(props) => {
            return (
              <History
                {...props}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                device={device}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/newAttention`}
          render={(props) => {
            return (
              <Send
                {...props}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
      </Switch>
    </div>
  );
}
